// extracted by mini-css-extract-plugin
export default {"pageHeader":"TeacherClassesView_pageHeader__RRlW2","backBtn":"TeacherClassesView_backBtn__QScro","pageTitle":"TeacherClassesView_pageTitle__XQaYk"};